
import { Component, Vue, Prop } from "vue-property-decorator";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";

@Component({
  components: {
    IntroduceCard
  }
})
export default class Appearance extends Vue {
  @Prop({ type: Object, required: true }) formItemData!: ExamVersionInfo;

  formItemCheck() {
    return new Promise((resolve, reject) => {
      resolve("");
    });
  }
}
